import gql from 'graphql-tag'

export const REENVIAR_NOTA = gql`
  mutation ReenviarNotas {
    reenviarNotas
  }
`
